// Business test only on production (temporary code): RS-7263
function googleReviewRequestInit() {
  const viewName = Skubacz.configuration.view_name;
  if (viewName !== "review" && viewName !== "reviews") return;

  function handleVisibility(setSessionStorage = false) {
    const reviewRequestEl = document.querySelector(".js-google-review-request");
    const radioChecked = document.querySelector(
      'input[name="review[restaurant_rating]"]:checked'
    );
    const ratingThreshold = 4;
    const restaurantRatingValue = radioChecked
      ? parseInt(radioChecked.value)
      : parseInt(sessionStorage.getItem("restaurantRatingReview")) >=
        ratingThreshold
      ? ratingThreshold
      : 0;

    if (reviewRequestEl) {
      reviewRequestEl.style.display =
        restaurantRatingValue >= ratingThreshold ? "block" : "none";
    }

    if (setSessionStorage) {
      sessionStorage.setItem("restaurantRatingReview", restaurantRatingValue);
    }
  }

  const reviewForm = document.querySelector('[action="/reviews"]');
  const radios = document.querySelectorAll(
    'input[name="review[restaurant_rating]"]'
  );

  if (radios.length) {
    radios.forEach((radio) =>
      radio.addEventListener("change", () => handleVisibility(false))
    );
  }

  if (reviewForm) {
    reviewForm.addEventListener("submit", () => handleVisibility(true));
  }

  // Init static pages (e.g. reviews view).
  if (viewName !== "review") {
    handleVisibility(false);
  }
}

/**
 * Display the appropriate number of stars according to the selected radio.
 *
 * @param {NodeList} radios All radios in a group.
 * @param {HTMLElement} selected Selected radio.
 */
function selectRate(radios, selected) {
  radios.forEach((radio) => {
    const label = radio.parentNode;

    if (radio.value <= selected.value) {
      label.classList.remove("icon-star-empty");
      label.classList.add("icon-star");
    } else {
      label.classList.remove("icon-star");
      label.classList.add("icon-star-empty");
    }
  });
}

/**
 * Stars rating for review component with native radio inputs.
 */
export function init() {
  const ratingGroups = document.querySelectorAll(".js-rating");

  googleReviewRequestInit();
  ratingGroups.forEach((group) => {
    const radios = group.querySelectorAll('input[type="radio"]');

    radios.forEach((radio) =>
      radio.addEventListener("change", () => selectRate(radios, radio), false)
    );
  });
}
